var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { connectionStore, ConnectionNames, ConfigStore } from "../../../Stores";
export function onTokenRenew(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        const conn = connectionStore.get(ConnectionNames.sports);
        const connConfig = ConfigStore.config.urls[ConnectionNames.sports];
        if (conn &&
            connConfig &&
            payload.data[0].token !== connConfig.queryParams.jwt) {
            const token = payload.data[0].token;
            connConfig.queryParams.jwt = token;
            conn.updateToken(token);
            yield conn.deactivate();
        }
    });
}
//# sourceMappingURL=OnTokenRenew.js.map